module.exports = __webpack_public_path__ + "static/media/right.68a47335.svg";